<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerStyle1"  md10 lg10 xs12 sm12>
        <img :src="img1" style="width:100%;">
      </v-flex>
    </v-layout>
    <v-layout row>
      <router-view></router-view>
    </v-layout>
 
  </v-container>
</template>

<script>
import img1 from "../../assets/Captura2.png";
export default {
  data() {
    return {
      img1: img1,
              items: [
          { title: '° Video', icon: 'dashboard',path: 'video' },
          { title: '° Lineamientos Estratégicos', icon: 'dashboard',path: 'estrategico' },
          { title: '° Diagnostico', icon: 'question_answer', path: 'name'},
          { title: '° Planes Operaticos', icon: 'question_answer', path: 'name' },
          { title: '° Indicadores', icon: 'question_answer', path: 'name'},
        ],
        right: null
    };
  },
  methods:{
    redirect(path){
      this.$router.push({name: path})
    }
  }
};
</script>


<style scoped>
.containerStyle1 {
  width: 100%;
  margin-top: 50px !important;
}

.drawner{
  width: 200px!important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #394049 !important;

}

.drawner2{
  width: 100%!important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;

}

.font{
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/template/TemplateDge.vue